export default {"src":"/_next/static/media/hero.c81b4c3f.svg","height":393,"width":592,"blurWidth":0,"blurHeight":0};